import util from '@bmp-vue/core/api/util'

const controller = 'CedenteAgendaRecebiveis'

export default Object.assign({}, util.GetCrud(controller, null), {
  ListarConsolidados: function (dto) {
    return util.Axios.GetAll(`${controller}/ComboCorrentistasCedentesConsolidados`, dto)
  },
})
